import { Validator } from 'class-propper';


const NAME_RE = /^[$A-Z_][0-9A-Z_$]*$/i;
const RESERVED_NAMES = 'abstract,else,instanceof,super,boolean,enum,int,switch,break,export,interface,synchronized,byte,extends,let,this,case,false,long,throw,catch,final,native,throws,char,finally,new,transient,class,float,null,true,const,for,package,try,continue,function,private,typeof,debugger,goto,protected,var,default,if,public,void,delete,implements,return,volatile,do,import,short,while,double,in,static,with'
  .split(',');

const nameValidator = new Validator([
  new Validator(s => !s, 'cannot have blank name'),
  'string',
  new Validator(s => !NAME_RE.test(s), '#value# is a bad js name'),
  new Validator(s => RESERVED_NAMES.includes(s), '#value# is RESERVED_NAMES'),
]);

const actionsValidator = new Validator([
  new Validator('object'),
  new Validator(
    actions => Object.keys(actions)
      .reduce((error, key) => error || nameValidator.try(key), false),
    (value, result) => result,
  ),
  new Validator(
    actions => Object.keys(actions).reduce((error, key) => (error || (typeof actions[key] !== 'function') ? key : false), false),
    (value, key) => `action "${key} is not a function`,
  ),
]);

export { actionsValidator, nameValidator };



// WEBPACK FOOTER //
// ./src/components/validators.js